import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import { utrTypeIds } from '../../../../../utils/eventConstants';
import { eventDivisionIsPlatformPaymentOrFree, isDinglesDivision } from '../../../../../utils/events';

import styles from './divisionPrice.scss';

const DivisionPrice = (props) => {
    const {
        division,
        clubVerificationFee,
        allowOffPlatformPayments,
        workflowVersion,
        utrTypeId,
        className,
        'data-testid': dataTestId,
    } = props;

    const {
        price,
        priceNonPowered,
    } = division;

    const auth = useSelector(({ auth }) => auth);

    const isSanctioned = utrTypeId === utrTypeIds.SANCTIONED;
    const userIsPowered = auth.user?.isPowered;

    const isOffPlatformPaymentOrFreeDivision = eventDivisionIsPlatformPaymentOrFree(division);
    const showNonPoweredPrice = isOffPlatformPaymentOrFreeDivision && !allowOffPlatformPayments;

    const isDivisionDingles = isDinglesDivision(division);

    const showPoweredPrice = isSanctioned &&
        workflowVersion > 1 &&
        clubVerificationFee > 0 &&
        !isDivisionDingles &&
        showNonPoweredPrice;

    if (showPoweredPrice) {
        return (
            <div className={styles.divisionPrice} data-testid={dataTestId}>
                <span
                    className={`${styles.nonPoweredPrice} ${userIsPowered ? 'line-through' : ''}`}
                    data-testid={dataTestId && `${dataTestId}.non-powered-price`}
                >
                    {priceNonPowered}
                </span>
                <span className={styles.nonPoweredPrice}> / </span>
                <span
                    className={`${userIsPowered ? styles.poweredPrice : ''}`}
                    data-testid={dataTestId && `${dataTestId}.powered-price`}
                >
                    {price}
                </span>
            </div>
        );
    }

    return (
        <div className={`${className} ${styles.divisionPrice}`} data-testid={dataTestId}>
            {price}
        </div>
    );
};

DivisionPrice.propTypes = {
    division: PropTypes.objectOf(any).isRequired,
    clubVerificationFee: PropTypes.number,
    allowOffPlatformPayments: PropTypes.bool,
    workflowVersion: PropTypes.number,
    utrTypeId: PropTypes.number,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};

DivisionPrice.defaultProps = {
    className: '',
    clubVerificationFee: 0,
    allowOffPlatformPayments: false,
    workflowVersion: 1,
    utrTypeId: utrTypeIds.MYUTR,
    'data-testid': null,
};

export default DivisionPrice;
